/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'Folie {positionInSet} von {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Titel hinzufügen',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Anhalten',
  'company-hub.carousel-extension.carousel-navigation.play': 'Abspielen',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Weiter',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Zurück',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Frame hinzufügen',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Frames hinzufügen',
  'company-hub.carousel-extension.config-panel.layout.title': 'Layout auswählen',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Text mit Rahmen über dem Bild',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Einfarbiger Hintergrund',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Geteiltes Design',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Verknüpfen',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'AKTUALISIERT',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Kreise zum Anzeigen des Fortschritts',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniaturansichten',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Weitere Informationen zu Karussellen',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Gestalten Sie bis zu {number} rotierende Frames. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Gestalten Sie bis zu {number} rotierende Frames.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'Allgemein',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navigation',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Automatische Wiedergabe',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Stellen Sie Ihr Karussell so ein, dass im Anzeigemodus automatisch alle {number} Sekunden gescrollt wird.',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Inhalt',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Stile',
  'company-hub.carousel-extension.config-panel.title': 'Karussell',
  'company-hub.carousel-extension.description.field.label': 'Beschreibung',
  'company-hub.carousel-extension.description.placeholder':
    'Sie können diesen Rahmen so anpassen, dass ein Karussell entsteht.',
  'company-hub.carousel-extension.frame-spotlight.label': 'Frame {positionInSet} von {setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Hintergrundfarbe',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Ihre Text- und Hintergrundfarben sind mit Blick auf die Lesbarkeit nicht gut geeignet.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Der Text und die Hintergrundfarben sind mit Blick auf die Lesbarkeit gut geeignet.',
  'company-hub.carousel-extension.frame.text.color': 'Textfarbe',
  'company-hub.carousel-extension.hub-element.description':
    'Mehrere ansprechende Bilder, die in Rotation angezeigt werden',
  'company-hub.carousel-extension.hub-element.title': 'Karussell',
  'company-hub.carousel-extension.manifest.macro-description': 'Erstellen Sie ein rotierendes Trio dynamischer Frames.',
  'company-hub.carousel-extension.manifest.macro-title': 'Karussell',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Karussell [aktualisiert]',
  'company-hub.carousel-extension.placeholder.description':
    'Sie können diesen Rahmen so anpassen, dass ein Karussell entsteht.',
  'company-hub.carousel-extension.placeholder.title': 'Geben Sie Ihrem Rahmen einen Titel',
  'company-hub.carousel-extension.recommended.field.label': '(Empfohlen)',
  'company-hub.carousel-extension.title.field.label': 'Titel',
  'company-hub.carousel-extension.title.placeholder': 'Geben Sie Ihrem Rahmen einen Titel',
};
